// /components/simulator/SimulatorEngine.js

import { simulateTraditionalRental } from './engines/TraditionalRentalEngine';
import { simulateBankLending } from './engines/BankLendingEngine';
import { simulateRentToOwn } from './engines/RentToOwnEngine';
import { simulateRentToOwnGold } from './engines/RentToOwnGoldEngine';
import { simulateRentToOwnRealEstate } from './engines/RentToOwnRealEstateEngine';
// import { simulateRentToOwnBusiness } from './engines/RentToOwnBusinessEngine';
import { simulateRentToOwnStock } from './engines/RentToOwnStockEngine';
import { simulateGoldInvestment } from './engines/GoldInvestmentEngine';
import { simulateStockInvestment } from './engines/StockInvestmentEngine';
// import { simulateBusinessInvestment } from './engines/BusinessInvestmentEngine';


  export const simulateModels = (params) => {
    if (!params || !params.modelName) {
      return { investorResult: null, borrowerResult: null, yearlyData: [] };
    }

  switch (params.modelName) {
    case 'Traditional Rental':
      return simulateTraditionalRental(params);
    case 'Bank Lending':
      return simulateBankLending(params);
    case 'Rent-to-Own':
      return simulateRentToOwn(params);
    case 'Rent-to-Own + Gold':
      return simulateRentToOwnGold(params);
    case 'Rent-to-Own + Real Estate':
      return simulateRentToOwnRealEstate(params);
    // case 'Rent-to-Own + Business':
    //   return simulateRentToOwnBusiness(params);
    case 'Rent-to-Own + Stock':
      return simulateRentToOwnStock(params);
    case 'Gold Investment':
      return simulateGoldInvestment(params);
    case 'Stock Investment':
      return simulateStockInvestment(params);
    // case 'Business Investment':
    //   return simulateBusinessInvestment(params);
    default:
      throw new Error(`Unknown model name: ${params.modelName}`);
  }
};

  
  export const calculateSimulation = (modelName, params) => {
    if (!modelName) {
      return { investorResult: null, borrowerResult: null, yearlyData: [] };
    }
  
    const { investorResult, borrowerResult, yearlyData } = simulateModels({ ...params, modelName });
    return { investorResult, borrowerResult, yearlyData };
  };
  